import { ILogger } from '@notes/webintegrations-common'

/**
 * Domain-specific log wrapper over the more project-agnostic
 * logging classes. Anything coupled to our build system can be
 * safely used here.
 */
export class Log {
  private static loggerInstance: ILogger

  static get logger(): ILogger {
    if (!this.loggerInstance) {
      throw new Error('Logger has not been initialized. Call Log.initialize!')
    }
    return Log.loggerInstance
  }

  static initialize(logger: ILogger): void {
    if (!this.loggerInstance) {
      Log.loggerInstance = logger
    } else {
      Log.loggerInstance.warn('Attempted to initialize logger after it has already been initialized. This is a no-op.')
    }
  }
}
